import React from 'react';
import styles from './ButtonMembership.module.scss';
import { ButtonBase } from './ButtonBase.tsx';
import MembershipIconPlus from '@static/images/membership_icon_plus.svg';
import MembershipIconPremium from '@static/images/membership_icon_premium.svg';
import MembershipIconElite from '@static/images/membership_icon_elite.svg';
import { Image } from '../Image/index.ts';
export const BUTTON_MEMBERSHIP_VARIANTS = [
    'plus',
    'premium',
    'elite'
];
const VARIANT_BACKGROUNDS = {
    plus: styles.plusBackground,
    premium: styles.premiumBackground,
    elite: styles.eliteBackground
};
const VARIANT_TEXT_COLORS = {
    plus: styles.plusTextColor,
    premium: styles.premiumTextColor,
    elite: styles.eliteTextColor
};
const VARIANT_ICONS = {
    plus: MembershipIconPlus,
    premium: MembershipIconPremium,
    elite: MembershipIconElite
};
const VARIANT_ICON_ALTS = {
    plus: 'strings:imgAlts.StoreMembershipPlus',
    premium: 'strings:imgAlts.StoreMembershipPremium',
    elite: 'strings:imgAlts.StoreMembershipElite'
};
export const ButtonMembership = ({ variant, children, ...rest })=>{
    return /*#__PURE__*/ React.createElement(ButtonBase, {
        backgroundColor: VARIANT_BACKGROUNDS[variant],
        textColor: VARIANT_TEXT_COLORS[variant],
        ...rest
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.memberIcon,
        image: {
            src: VARIANT_ICONS[variant],
            alt: VARIANT_ICON_ALTS[variant]
        }
    }), children);
};
